import { render, staticRenderFns } from "./OptimizeWeights.vue?vue&type=template&id=0e8cc351&scoped=true"
import script from "./OptimizeWeights.vue?vue&type=script&lang=ts"
export * from "./OptimizeWeights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8cc351",
  null
  
)

export default component.exports